<template>
  <section class="page_title ls s-py-5 d-none d-sm-block">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h1 class="titulo">{{ mensaje }}</h1>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      mensaje: 'Esto es un mensaje dinámico de VUE.js desde el componente Pagetitle'
    }
  }
}
</script>


